const REDIS_HOST = process.env.REDIS_HOST || '194.156.67.86';
const REDIS_PASSWORD = process.env.REDIS_PASSWORD || '.1&q3,oO45S2d{)*';
// const REDIS_HOST = process.env.REDIS_HOST || 'localhost';
const REDIS_PORT = process.env.REDIS_PORT || 6379;
const REDIS_DB = process.env.REDIS_DB || 1;
const { CACHE_EXCLUSIONS } = require('../constants');
const TOKEN = process.env.TOKEN;
const CACHE_PREFIX = process.env.CACHE_PREFIX || 'cache_prod';
import { logTime } from '../utils/logtime.js';

export default async (req, res, next) => {
    const cookies = req.headers.cookie || '';
    const parseCookies = str =>
        str.split('; ').reduce((acc, cookie) => {
            const [key, value] = cookie.split('=');
            acc[key] = decodeURIComponent(value);
            return acc;
        }, {});

    let cookiesObject = parseCookies(cookies);

    const queryIndex = req.url.indexOf('?');
    const hasQuery = queryIndex !== -1;
    const path = hasQuery ? req.url.substring(0, queryIndex) : req.url;
    let userId = 0;

    const userGroupIdInCookie = cookiesObject?.['user-group-id'];

    if (userGroupIdInCookie) {
        userId = userGroupIdInCookie;
    }

    if (!cookiesObject.firstVisit) {
        next();
        return;
    }

    if (path?.endsWith('/')) {
        next();
        return;
    }

    let redis;
    try {
        const shouldExclude = CACHE_EXCLUSIONS.some(element => req.url.startsWith(element));

        if (shouldExclude) {
            next();
            return;
        }
        const urlHasQuery = req.url.includes('?');
        if (urlHasQuery) {
            next();
            return;
        }

        console.log('[Cache middleware] | Processing...');
        console.log('[Cache middleware] | Request URL:', req.url);
        const startTime = process.hrtime();

        logTime('[Cache middleware] | Start importing redis', startTime);

        logTime('[Cache middleware] | Redis imported', startTime);

        function modifyStringIfMissing(str1, str2) {
            const segments = str1.split('/');

            if (segments[1] !== str2) {
                segments[1] = str2;
            }

            return '/' + segments.filter(Boolean).join('/');
        }

        const cookies = req.headers.cookie || '';

        const parseCookies = str => Object.fromEntries(str.split('; ').map(cookie => cookie.split('=').map(decodeURIComponent)));
        let cookiesObject = parseCookies(cookies);

        if (req.url.split('/')[1] !== cookiesObject.i18n_redirected) {
            next();
            return;
        }

        const cacheKey = `page:${CACHE_PREFIX}_${TOKEN}_${userId}__${modifyStringIfMissing(
            req.url,
            cookiesObject.i18n_redirected
        )}.${cookiesObject.is_age_valid}`;
        const { Redis } = await import('ioredis');
        logTime('[Cache middleware] | Connecting to redis', startTime);
        redis = new Redis({
            host: REDIS_HOST,
            port: REDIS_PORT,
            db: REDIS_DB,
            enableReadyCheck: false,
            password: REDIS_PASSWORD,
        });

        const redisWithTimeout = (action, timeout) =>
            Promise.race([
                action,
                new Promise((_, reject) => setTimeout(() => reject(new Error('Redis timeout exceeded')), timeout)),
            ]);

        logTime('[Cache middleware] | Connected to redis', startTime);
        // const cachedPage = await redis.get(cacheKey);
        const cachedPage = await redisWithTimeout(redis.get(cacheKey), 2000);

        logTime('[Cache middleware] | Disconnecting from redis', startTime);
        if (cachedPage) {
            logTime('[Cache middleware] | cachedPage has been found', startTime);
            res.setHeader('Content-Type', 'text/html');
            logTime('[Cache middleware] | set header', startTime);
            res.end(cachedPage);
            if (redis) {
                console.log('[Cache middleware] | Disconnecting from redis');
                redis.disconnect();
            }
        } else {
            logTime('[Cache middleware] | cachedPage has not been found', startTime);
            res.sendResponse = res.end;
            logTime('[Cache middleware] | res.sendResponse = res.end', startTime);
            res.end = async body => {
                if (res.statusCode === 200) {
                    logTime('[Cache middleware | Setting to cache', startTime);
                    await redis.set(cacheKey, body, 'EX', 60 * 60 * 2); // Cache for 1 hour
                    logTime('[Cache middleware] | Set cache', startTime);
                }
                redis.disconnect();
                res.sendResponse(body);
            };
            next();
        }
    } catch (e) {
        console.log('[Cache middleware] | Error while processing cache: ', e);
        if (redis) {
            redis.disconnect();
            console.log('[Cache middleware] | Disconnecting from redis in catch');
        }
        next();
    }
};
